import { useAppDispatch } from '@/hooks';
import { setAgeModalOpen } from '@/store/slices/uiSlice';
import InstallButton from './InstallButton';

const Footer = () => {
  const dispatch = useAppDispatch();

  return (
    <footer className="w-full bg-footer-bg px-5 py-10 text-body-inverse">
      <div className="mx-auto max-w-[1500px]">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Logo Section */}
          <div className="flex flex-col items-center justify-start">
            <img
              className="max-h-40 max-w-full object-contain"
              src="/images/logo/logo.png"
              alt="Site logo"
            />
          </div>

          {/* Menu Section */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="mb-4 text-lg font-semibold text-primary">Menu</h3>
            <div className="space-y-2 text-sm">
              <p className="cursor-pointer transition-colors hover:text-primary">About Us</p>
              <p className="cursor-pointer transition-colors hover:text-primary">Privacy Policy</p>
              <p className="cursor-pointer transition-colors hover:text-primary">Rules</p>
            </div>
          </div>

          {/* Game Therapy Section */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="mb-4 text-lg font-semibold text-primary">Game Therapy</h3>
            <div className="flex flex-col items-center gap-3 md:items-start">
              <div className="flex gap-2">
                <img
                  onClick={() => dispatch(setAgeModalOpen(true))}
                  className="h-10 w-10 cursor-pointer transition-transform hover:scale-110"
                  src="/images/18plus.png"
                  alt="18+"
                  title="Age Restriction"
                />
                <img
                  className="h-10 w-10 object-contain"
                  src="/images/gamecare.png"
                  alt="Game care"
                  title="Game Therapy"
                />
              </div>
              <InstallButton />
            </div>
          </div>

          {/* Follow Us / Security Section */}
          <div className="flex flex-col items-center md:items-start">
            <h3 className="mb-4 text-lg font-semibold text-primary">Security</h3>
            <div className="flex flex-col items-center gap-2 md:items-start">
              <img
                className="max-h-20 max-w-full object-contain"
                src="/images/secure.png"
                alt="Secure connection"
              />
              <div>
                <p className="font-bold text-green-400">100% SAFE</p>
                <p className="text-xs">Protected connection and encrypted data.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <p className="mt-8 rounded-t-md bg-surface py-3 text-center text-sm text-body">
          © Copyright 2026 <span className="font-semibold">Vishnu7</span>. All rights reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
